import { render } from "./WizardApp.vue?vue&type=template&id=6f15555f"
import script from "./WizardApp.vue?vue&type=script&lang=js"
export * from "./WizardApp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/vue/apps/WizardApp.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6f15555f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6f15555f', __exports__)) {
    api.reload('6f15555f', __exports__)
  }
  
  module.hot.accept("./WizardApp.vue?vue&type=template&id=6f15555f", () => {
    api.rerender('6f15555f', render)
  })

}


export default __exports__